import { EntityRepository, Repository } from "typeorm";
import { ProductInspection } from "./product-inspection.entity";

@EntityRepository(ProductInspection)
export class ProductInspectionRepository extends Repository<ProductInspection> {

}